import { useState } from "react";
import { faqItems } from "@/mocks/faq";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-16">
      <div className="container-editorial">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-[0.18em] text-primary-600 uppercase">
              <span className="h-px w-6 bg-primary-500" />
              FAQ
            </span>
            <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-[28px]">
              关于内幕与线索的常见问题
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              关于信源、更新节奏与判断方式，这里回答了读者问得最多的几个问题。还有疑问可以来信，我们会挑共性的问题补充进来。
            </p>
            <div className="mt-6 rounded-lg border border-background-200/80 bg-background-100/60 p-4">
              <p className="flex items-start gap-2 text-sm text-foreground-700">
                <i className="ri-mail-line mt-0.5 text-base text-primary-600" />
                <span>
                  线索邮箱：
                  <span className="font-medium text-foreground-950">tips@redian-neimu.example.com</span>
                </span>
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200/80 bg-background-50">
              {faqItems.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.question}>
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100/70"
                      >
                        <span className="flex items-start gap-3">
                          <span className="mt-0.5 font-heading text-sm font-bold text-primary-600">
                            {String(index + 1).padStart(2, "0")}
                          </span>
                          <span className="font-heading text-base font-semibold text-foreground-950">
                            {item.question}
                          </span>
                        </span>
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                            isOpen ? "bg-primary-600 text-background-50" : "bg-background-200 text-foreground-700"
                          }`}
                        >
                          <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`} />
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="px-5 pb-5 pl-[3.6rem] pr-14 animate-fade-in">
                        <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}